import { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import NiceModal from "@ebay/nice-modal-react";
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import UnitLabelModal from "../UnitLabelModal/UnitLabelModal";
import unitAdminService from "../../services/unitAdminService";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import "./UnitTable.css";

function UnitTable() {
    const toast = useToastDispatchContext();
    const { getUnitLabels, deleteUnitLabel } = unitAdminService;
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const fetchUnitLabels = async () => {
            const [response, error] = await getUnitLabels();
            if (error || !response) {
                toast.error("Error", "Unable to load units");
                return;
            }
            setRows(response.data || []);
        };
        fetchUnitLabels();
    }, []);

    const onClickAdd = () =>
        NiceModal.show(UnitLabelModal, { title: "Create a new unit" })
            .then((unit) => setRows((prev) => [unit, ...prev]));

    const onClickUpdate = (row) =>
        NiceModal.show(UnitLabelModal, { title: "Edit unit", data: row })
            .then((unit) => setRows((prev) => prev.map((r) => (r.id === unit.id ? unit : r))));

    const onClickDelete = (row) =>
        ModalManager.show(ApiModal, {
            title: "Delete unit " + row.unit_id,
            body: "Do you really want to delete the unit \"" + row.label + "\" (" + row.unit_id + ") ?",
            api: { request: deleteUnitLabel, param: [row.id] },
            buttons: [
                { className: "validate", label: "Cancel", style: { marginRight: "20px" } },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        }).then((res) => {
            if (res?.error != null) {
                toast.error("Error", res.error);
                return;
            }
            setRows((prev) => prev.filter((r) => r.id !== row.id));
        });

    const columnDefs = [
        { headerName: "Unit ID", field: "unit_id", flex: 1, sortable: true, filter: true, floatingFilter: true },
        { headerName: "Label", field: "label", flex: 1, sortable: true, filter: true, floatingFilter: true },
        {
            headerName: "Actions",
            width: 100,
            pinned: "right",
            cellRenderer: (params) => (
                <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                    <i className="fas fa-edit action-button blue" onClick={() => onClickUpdate(params.data)} />
                    <i className="fas fa-trash action-button red" onClick={() => onClickDelete(params.data)} />
                </div>
            ),
        },
    ];

    return (
        <div className="unit-admin-grid-section">
            <div className="unit-admin-toolbar">
                <IconButton
                    className="main-iconButton profil_action unit-admin-add-button"
                    icon="fas fa-plus"
                    onClick={onClickAdd}
                    title="Add unit"
                />
            </div>
            <div className="ag-theme-alpine unit-admin-grid" style={{ width: "100%", height: "550px" }}>
                <AgGridReact
                    enableCellTextSelection={true}
                    rowData={rows}
                    rowHeight={48}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true, resizable: true }}
                    pagination={true}
                    paginationPageSize={50}
                />
            </div>
            <br></br>
        </div>
    );
}

export default UnitTable;
